import React from "react";
import {
    Badge,
    HStack,
    Box,
    Text,
} from "@chakra-ui/react";


const variants = {
    success: {
        bg: "#EAF8F1",
        color: "#2F9461",
        dot: "#55C48A",
    },

    warning: {
        bg: "#FFF7E8",
        color: "#C67A15",
        dot: "#F4B942",
    },

    danger: {
        bg: "#FDEDED",
        color: "#D64545",
        dot: "#EF6A6A",
    },

    info: {
        bg: "#EDF4FF",
        color: "#276EF1",
        dot: "#69A5FF",
    },

    gray: {
        bg: "#F4F5F7",
        color: "#6B7280",
        dot: "#9CA3AF",
    },

    purple: {
        bg: "#F4EEFF",
        color: "#7C3AED",
        dot: "#A78BFA",
    },

    infoDark: {
        bg: "#E8F0FF",
        color: "#3559E0",
        dot: "#4C6FFF",
    },

    teal: {
        bg: "#E6FFFA",
        color: "#0F766E",
        dot: "#14B8A6",
    },
    cyan: {
    bg: "#ECFEFF",
    color: "#0891B2",
    dot: "#22D3EE",
},

    pink: {
        bg: "#FDF2F8",
        color: "#BE185D",
        dot: "#EC4899",
    },

    blue: {
        bg: "#EFF6FF",
        color: "#2563EB",
        dot: "#60A5FA",
    },

    review: {
        bg: "#FFF3E0",
        color: "#E65100",
        dot: "#FF9800",
    },
};


const StatusBadge = ({
    label,
    variant = "gray",
}) => {

    const style =
        variants[variant] ||
        variants.gray;

    return (
        <Badge
            bg={style.bg}
            color={style.color}
            px={3}
            py={1.5}
            borderRadius="8px"
            textTransform="none"
            fontWeight="600"
            fontSize="13px"
        >
            <HStack spacing={2}>

                <Box
                    w="7px"
                    h="7px"
                    borderRadius="full"
                    bg={style.dot}
                />

                <Text
                    fontSize="13px"
                    fontWeight="600"
                >
                    {label}
                </Text>

            </HStack>
        </Badge>
    );
};


export default StatusBadge;


export const getStatusVariant = (
    status
) => {

    switch (status) {


        case true:
        case "True":
        case "Yes":
        case "Approved":
        case "Verified":
        case "Achieved":
        case "Paid":
        case "Delivered":
        case "Collected":
        case "Resolved":
        case "RESOLVED":

        // Starter Kit Purchase
        case "Payment Approved":
        case "Confirmed Received":

        // Contacted
        case "CONTACTED":
        case "Contacted":
            return "success";


        case "Pending":
        case "PENDING":
        case "OPEN":

        // Starter Kit Purchase
        case "Awaiting Payment":
        case "Payment Pending":
            return "warning";



        case "NOT_REACHED":
        case "Not Reached":
            return "danger";


        case "Awaiting Pick Up":
        case "Full":
            return "purple";


        case "Picked Up":
        case "Active":
            return "info";


        case "Review Required":
            return "info";


        case "In Transit":
        case "Processing":
        case "IN_PROGRESS":
            return "infoDark";



        case "Preparing Order":
            return "info";


        case "Dispatched":
            return "infoDark";


        case "CLOSED":
            return "gray";



        case false:
        case "False":
        case "No":
        case "Inactive":
        case "Suspended":
        case "Expired":
            return "warning";


        case "Rejected":
        case "Failed":
        case "Cancelled":
        case "Flagged":
            return "danger";


        default:
            return "gray";
    }
};


export const getCategoryVariant = (
    category
) => {

    switch (category) {

        case "Getting Started":
            return "success";

        case "Account Issues":
            return "blue";

        case "Payments":
            return "purple";

        case "Driver Support":
            return "warning";

        case "Technical Support":
            return "teal";

        case "General":
            return "pink";
        case "Driver Partner":
    return "cyan";

        case "Other":
            return "gray";

        default:
            return "gray";
    }
};